module.exports = __webpack_public_path__ + "static/backup-02c6a3e4d2a43dfb73bc9e4f6c42cf8d.png";